var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "doubleCode",
      attrs: {
        visible: _vm.columnVisible,
        width: "200px",
        modal: false,
        "show-close": false,
        "close-on-click-modal": "",
        "close-on-press-escape": ""
      },
      on: { close: _vm.handleSearchTableLoad }
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "10px" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 6 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "text-align": "center",
                    "margin-bottom": "10px"
                  },
                  attrs: { span: 24 }
                },
                [_vm._v("配置列")]
              ),
              _c(
                "el-col",
                { staticClass: "tool-btn", attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "addButton",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleSubmitSave }
                    },
                    [_vm._v("确认保存")]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "tool-btn", attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "outputButton",
                      attrs: { size: "small", type: "success" },
                      on: { click: _vm.handleAllSubmitSave }
                    },
                    [_vm._v("全部显示")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            _vm._l(_vm.columnList, function(item, index) {
              return _c(
                "el-col",
                {
                  key: index,
                  staticClass: "double-content",
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.columnSlect,
                        callback: function($$v) {
                          _vm.columnSlect = $$v
                        },
                        expression: "columnSlect"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "custom-checkbox",
                          attrs: {
                            size: "",
                            label: item.FIELD_NAME,
                            border: ""
                          }
                        },
                        [_vm._v(_vm._s(item.FIELD_CAPTION))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }